import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PublicRouterService } from '@core/modules/public/services/public-router.service';
import { SchedulerStore } from '@data/stores';

export const validateAccountContractGuard: CanActivateFn = (_, state) => {
  const store = inject(SchedulerStore);
  const router = inject(Router);
  const publicRouter = inject(PublicRouterService);

  if (!store.accountContractData()?.account) {
    if (state.url.includes('/public')) {
      publicRouter.goTo('/public/self-scheduled');
    } else {
      router.navigate(['/scheduler']);
    }

    return false;
  }

  return true;
};
